module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_c('f7-navbar', {
    staticClass: "navbar-container"
  }, [_c('f7-nav-left', {
    staticClass: "navbar-item"
  }, [_c('button', {
    staticClass: "open-panel",
    style: ({
      color: _vm.customization.mainColor
    }),
    attrs: {
      "data-panel": "left"
    },
    on: {
      "click": _vm.onMenuRight
    }
  }, [_c('svg', {
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 32 32",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.33334 24C4.95556 24 4.63912 23.872 4.384 23.616C4.12889 23.36 4.00089 23.0436 4 22.6667C3.99912 22.2898 4.12712 21.9733 4.384 21.7173C4.64089 21.4613 4.95734 21.3333 5.33334 21.3333H26.6667C27.0444 21.3333 27.3613 21.4613 27.6173 21.7173C27.8733 21.9733 28.0009 22.2898 28 22.6667C27.9991 23.0436 27.8711 23.3604 27.616 23.6173C27.3609 23.8742 27.0444 24.0018 26.6667 24H5.33334ZM5.33334 17.3333C4.95556 17.3333 4.63912 17.2053 4.384 16.9493C4.12889 16.6933 4.00089 16.3769 4 16C3.99912 15.6231 4.12712 15.3067 4.384 15.0507C4.64089 14.7947 4.95734 14.6667 5.33334 14.6667H26.6667C27.0444 14.6667 27.3613 14.7947 27.6173 15.0507C27.8733 15.3067 28.0009 15.6231 28 16C27.9991 16.3769 27.8711 16.6938 27.616 16.9507C27.3609 17.2076 27.0444 17.3351 26.6667 17.3333H5.33334ZM5.33334 10.6667C4.95556 10.6667 4.63912 10.5387 4.384 10.2827C4.12889 10.0267 4.00089 9.71022 4 9.33333C3.99912 8.95644 4.12712 8.64 4.384 8.384C4.64089 8.128 4.95734 8 5.33334 8H26.6667C27.0444 8 27.3613 8.128 27.6173 8.384C27.8733 8.64 28.0009 8.95644 28 9.33333C27.9991 9.71022 27.8711 10.0271 27.616 10.284C27.3609 10.5409 27.0444 10.6684 26.6667 10.6667H5.33334Z",
      "fill": "currentColor"
    }
  })])])]), _vm._v(" "), _c('f7-nav-center', {
    staticClass: "navbar-center"
  }, [_c('div', {
    staticClass: "logo_text"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [(_vm.isLogoShowed) ? _c('img', {
    attrs: {
      "src": _vm.computedLogo
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLogoShowed) ? _c('div', {
    staticClass: "salesperson-name",
    on: {
      "click": function($event) {
        return _vm.redirectToSiteUrl('home')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#7F7F7F"
    }
  }, [_vm._v(_vm._s(_vm.SalesPersonFirst))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.SalesPersonLast))])]) : _vm._e()])])]), _vm._v(" "), _c('f7-nav-right', {
    staticClass: "navbar-item"
  }, [_c('button', {
    staticClass: "open-panel",
    style: ({
      color: _vm.customization.mainColor
    }),
    attrs: {
      "data-panel": "right"
    },
    on: {
      "click": _vm.onMenuLeft
    }
  }, [_c('svg', {
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 32 32",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23 25C23 22.348 19.8663 20.2 16 20.2C12.1337 20.2 9 22.348 9 25M16 16.6C14.7623 16.6 13.5753 16.0943 12.7002 15.1941C11.825 14.2939 11.3333 13.073 11.3333 11.8C11.3333 10.527 11.825 9.30606 12.7002 8.40589C13.5753 7.50571 14.7623 7 16 7C17.2377 7 18.4247 7.50571 19.2998 8.40589C20.175 9.30606 20.6667 10.527 20.6667 11.8C20.6667 13.073 20.175 14.2939 19.2998 15.1941C18.4247 16.0943 17.2377 16.6 16 16.6Z",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-overlay nav-position-fixed",
    on: {
      "click": _vm.clearMargin
    }
  }), _vm._v(" "), _c('f7-panel', {
    staticClass: "nav-position-fixed right_nav",
    style: ({
      'background-color': _vm.customization.mainColor
    }),
    attrs: {
      "right": "",
      "cover": "",
      "layout": "light"
    }
  }, [_c('div', {
    staticClass: "rightContainer"
  }, [_c('div', {
    staticClass: "user_login_info"
  }, [_c('div', {
    staticClass: "user_thumb"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl,
      "alt": "",
      "title": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user_details"
  }, [_c('p', {
    style: ({
      color: _vm.customization.fontColor
    })
  }, [_vm._v("\n              Welcome,\n              "), _c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(_vm.customerUser.firstName + " " + _vm.customerUser.lastName))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.customerUser.isDemoUser ? '#' : 'edit-user-profile/'
    }
  }, [_c('div', {
    staticClass: "user_avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.customerUser.profilePhoto ?
        _vm.customerUser.profilePhoto :
        '/static/images/avatar.jpg',
      "alt": "",
      "title": ""
    }
  })])])]), _vm._v(" "), _c('nav', {
    staticClass: "user-nav"
  }, [_c('ul', [_c('li', {
    style: ({
      'border-bottom-color': _vm.customization.iconColor
    })
  }, [_c('a', {
    staticClass: "close-panel",
    attrs: {
      "href": _vm.customerUser.isDemoUser ? '#' : 'edit-user-profile'
    },
    on: {
      "click": _vm.clearMargin
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-user-circle",
    style: ({
      color: _vm.customization.iconColor
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "right-nav-span",
    style: ({
      color: _vm.customization.fontColor,
      'font-size': '16px',
    })
  }, [_vm._v("My Profile")])])]), _vm._v(" "), (_vm.videoMessageCount != 0) ? _c('li', {
    style: ({
      'border-bottom-color': _vm.customization.iconColor
    })
  }, [_c('a', {
    staticClass: "close-panel",
    attrs: {
      "href": "video-message"
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-video",
    style: ({
      color: _vm.customization.iconColor
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "right-nav-span",
    style: ({
      color: _vm.customization.fontColor,
      'font-size': '16px',
    })
  }, [_vm._v("Video Messages")])]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    style: ({
      color: _vm.customization.mainColor,
      'background-color': _vm.customization.iconColor,
    })
  }, [_vm._v(_vm._s(_vm.videoMessageCount))])]) : _vm._e(), _vm._v(" "), (_vm.slsPermission.recommendAFriend) ? _c('li', {
    style: ({
      'border-bottom-color': _vm.customization.iconColor
    })
  }, [_c('a', {
    staticClass: "close-panel",
    attrs: {
      "href": "recommendfriend"
    },
    on: {
      "click": function($event) {
        return _vm.setPageShare(_vm.SharepageEnum.history)
      }
    }
  }, [_c('span', {
    staticClass: "dbc-icon dbc-icon-users-three",
    style: ({
      color: _vm.customization.iconColor
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "right-nav-span",
    style: ({
      color: _vm.customization.fontColor,
      'font-size': '16px',
    })
  }, [_vm._v("Refer")])]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    style: ({
      color: _vm.customization.mainColor,
      'background-color': _vm.customization.iconColor,
    })
  }, [_vm._v(_vm._s(_vm.referralsCount))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "termContainer"
  }, [_c('a', {
    staticClass: "close-panel",
    attrs: {
      "href": "terms"
    }
  }, [_vm._v(" Terms and Conditions ")]), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.customization.fontColor
    })
  }, [_vm._v("and")]), _vm._v(" "), _c('a', {
    staticClass: "close-panel",
    attrs: {
      "href": "policy"
    }
  }, [_vm._v(" Privacy Policy ")])])])]), _vm._v(" "), _c('f7-panel', {
    staticClass: "nav-position-fixed left_nav",
    style: ({
      'background-color': _vm.customization.mainColor
    }),
    attrs: {
      "left": "",
      "cover": "",
      "layout": "light"
    }
  }, [_c('nav', {
    staticClass: "icons_31 sidebar-nav"
  }, [_c('list-menu-component', {
    attrs: {
      "items": _vm.customButtons,
      "fontColor": _vm.customization.fontColor,
      "iconColor": _vm.customization.iconColor
    },
    on: {
      "onClick": function($event) {
        return _vm.OnItemClick($event)
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4767b395", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4767b395"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/navbar.vue
// module id = 824
// module chunks = 0